class NotificationHelper {
  static notify(text) {
    if ('Notification' in window && Notification.permission === 'granted') {
      new Notification(text);
    }
  }

  static dispatch(message, auto_close_time) {
    const event = document.createEvent('Event');
    event.initEvent('SnackbarMessage', true, true);
    event.value = message;
    event.auto_close_time = auto_close_time;
    document.dispatchEvent(event);
  }

  static snack(message, auto_close_time) {
    NotificationHelper.dispatch(message, auto_close_time);
  }

  static showErrorPage(code) {
    NotificationHelper.dispatch(code);
  }

  static successCreate() {
    NotificationHelper.dispatch('Registro(s) criado(s) com sucesso!');
  }

  static successUpdate() {
    NotificationHelper.dispatch('Registro(s) atualizado(s) com sucesso!');
  }

  static successDelete() {
    NotificationHelper.dispatch('Registro(s) removido(s) com sucesso!');
  }

  static duplicatedData() {
    NotificationHelper.dispatch('Já existe um registro com esses dados.');
  }
}

export default NotificationHelper;
